export function getError(error) {
  let customError = 'Erro interno, tente mais tarde';
  if (error.response && error.response.data
    && error.response.data.erro
    && error.response.data.erro.mensagem) {
    customError = error.response.data.erro.mensagem;
  }
  return customError;
}
export function createError(error) {
  console.log(error);
}
